import React, { useEffect, useState } from 'react'
import styles from './Main.module.sass'
import milprice_icon from '../../../assets/mil_price_icon.svg'
import transactions_icon from '../../../assets/transactions_icon.svg'
import market_cap_icon from '../../../assets/market_cap_icon.svg'
import graph_svg from '../../../assets/graph.svg'
import last_finalized_block_icon from '../../../assets/last_finalized_block_icon.svg'
import { LatestBlocks } from './LatestBlocksComponent/LatestBlocks'
import { LatestTransactions } from './LatestTransactionComponent/LatestTransactions'
import { Block, Transaction } from '../../../app/models/generated'
import { initialStats, Stats } from '../../../app/models/Stats'
import { Search } from '../../ui/Search'
import { Icon } from '../../ui/Icon'
import { NavLink } from 'react-router-dom'
import { formatNumber, round } from '../../../utils'
import {
    getBlocks,
    getStats,
    getTransactions,
} from '../../../services/MainPageService'
import { useMediaQuery } from '@chakra-ui/react'

export const Main = () => {
    const [stats, setStats] = useState<Stats>(initialStats)
    useEffect(() => {
        getStats(setStats)
    }, [])

    const [blocks, setBlocks] = useState<Array<Block>>([])
    useEffect(() => {
        getBlocks(setBlocks)
    }, [])

    const [transactions, setTransactions] = useState<Array<Transaction>>([])
    useEffect(() => {
        getTransactions(setTransactions)
    }, [])

    const dailyTransactions =
        Number(stats.transactions_today) > 1000
            ? stats.transactions_today.substring(0, 3) +
              '.' +
              stats.transactions_today.substring(3, 4) +
              'K'
            : stats.transactions_today
    const averageBlockTime = (stats.average_block_time / 1000).toFixed(1)
    const gasPrices = formatNumber(round(Number(stats.gas_prices?.average), 5))
    const [largerThan768px] = useMediaQuery('(min-width: 768px)')
    return (
        <div className={styles.main}>
            <section className={styles.infoSection}>
                <h1 className={styles.welcome}>The Blockchain Explorer</h1>

                <section className={styles.searchSection}>
                    <Search />
                </section>
                {largerThan768px ? (
                    <div className={styles.maincard}>
                        <div className={`${styles.cards} ${styles.wid67}`}>
                            <div className={styles.bigpaircard}>
                                <div
                                    className={`${styles.card} ${styles.wid33}`}>
                                    <img
                                        src={milprice_icon}
                                        alt="milprice_icon"
                                    />
                                    <div className={styles.cardInfo}>
                                        <p className={styles.cardName}>
                                            MIL PRICE
                                        </p>
                                        <p className={styles.cardValue}>
                                            {/* Change to Value of MIL_PRICE */}
                                            {formatNumber(stats.total_blocks)}
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className={`${styles.paircard} ${styles.wid67}`}>
                                    <div className={styles.card}>
                                        <img
                                            src={transactions_icon}
                                            alt="transactions_icon"
                                        />
                                        <div className={styles.cardInfo}>
                                            <p className={styles.cardName}>
                                                TRANSACTIONS
                                            </p>
                                            <p className={styles.cardValue}>
                                                {/* Change to Value of Transactions */}
                                                {averageBlockTime}
                                            </p>
                                        </div>
                                    </div>
                                    <div className={styles.card}>
                                        <div className={styles.cardInfo}>
                                            <p className={styles.cardName}>
                                                MED GAS PRICE
                                            </p>
                                            <p
                                                className={`${styles.cardValue} ${styles.textalignright}`}>
                                                {/* Change to Value of Med Gas Price */}
                                                {averageBlockTime}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.bigpaircard}>
                                <div
                                    className={`${styles.card} ${styles.wid40}`}>
                                    <img
                                        src={market_cap_icon}
                                        alt="market_cap_icon"
                                    />
                                    <div className={styles.cardInfo}>
                                        <p className={styles.cardName}>
                                            MARKET CAP
                                        </p>
                                        <p className={styles.cardValue}>
                                            {/* Change to Value of Market Cap */}
                                            {formatNumber(
                                                stats.total_transactions
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className={`${styles.paircard} ${styles.wid60}`}>
                                    <div className={styles.card}>
                                        <img
                                            src={last_finalized_block_icon}
                                            alt="last_finalized_block_icon"
                                        />
                                        <div className={styles.cardInfo}>
                                            <p className={styles.cardName}>
                                                LAST FINALIZED BLOCK
                                            </p>
                                            <p className={styles.cardValue}>
                                                {/* Change to Value of Last Finalized Block*/}
                                                {formatNumber(
                                                    stats.total_addresses
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className={styles.card}>
                                        <div className={styles.cardInfo}>
                                            <p className={styles.cardName}>
                                                LAST SAFE BLOCK
                                            </p>
                                            {/* Change to Value of LAST SAFE BLOCK*/}
                                            <p
                                                className={`${styles.cardValue} ${styles.textalignright}`}>
                                                {gasPrices}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.cards} ${styles.wid33}`}>
                            <div className={styles.rightfont}>
                                TRANSACTION HISTORY IN 14 DAYS
                            </div>
                            <div className={styles.totalbar}>
                                <div className={styles.kbar}>
                                    <div>1150K</div>
                                    <div>950k</div>
                                </div>
                                <div className={styles.graphbar}>
                                    <img src={graph_svg} alt="graph_svg" />
                                </div>
                            </div>
                            <div className={styles.numbar}>
                                <div>Jun 26</div>
                                <div>Aug 2</div>
                                <div>Aug 9</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={styles.maincard}>
                            <div className={`${styles.cards} ${styles.wid67}`}>
                                <div className={styles.bigpaircard}>
                                    <div
                                        className={`${styles.card} ${styles.wid33}`}>
                                        <img
                                            src={milprice_icon}
                                            alt="milprice_icon"
                                        />
                                        <div className={styles.cardInfo}>
                                            <p className={styles.cardName}>
                                                MIL PRICE
                                            </p>
                                            <p className={styles.cardValue}>
                                                {/* Change to Value of MIL_PRICE */}
                                                {formatNumber(
                                                    stats.total_blocks
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className={`${styles.paircard} ${styles.wid67}`}>
                                        <div className={styles.card}>
                                            <img
                                                src={transactions_icon}
                                                alt="transactions_icon"
                                            />
                                            <div className={styles.cardInfo}>
                                                <p className={styles.cardName}>
                                                    TRANSACTIONS
                                                </p>
                                                <p className={styles.cardValue}>
                                                    {/* Change to Value of Transactions */}
                                                    {averageBlockTime}
                                                </p>
                                            </div>
                                        </div>
                                        <div className={styles.card}>
                                            <div className={styles.cardInfo}>
                                                <p className={styles.cardName}>
                                                    MED GAS PRICE
                                                </p>
                                                <p
                                                    className={`${styles.cardValue} ${styles.textalignright}`}>
                                                    {/* Change to Value of Med Gas Price */}
                                                    {averageBlockTime}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.bigpaircard}>
                                    <div
                                        className={`${styles.card} ${styles.wid40}`}>
                                        <img
                                            src={market_cap_icon}
                                            alt="market_cap_icon"
                                        />
                                        <div className={styles.cardInfo}>
                                            <p className={styles.cardName}>
                                                MARKET CAP
                                            </p>
                                            <p className={styles.cardValue}>
                                                {/* Change to Value of Market Cap */}
                                                {formatNumber(
                                                    stats.total_transactions
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className={`${styles.paircard} ${styles.wid60}`}>
                                        <div className={styles.card}>
                                            <img
                                                src={last_finalized_block_icon}
                                                alt="last_finalized_block_icon"
                                            />
                                            <div className={styles.cardInfo}>
                                                <p className={styles.cardName}>
                                                    LAST FINALIZED BLOCK
                                                </p>
                                                <p className={styles.cardValue}>
                                                    {/* Change to Value of Last Finalized Block*/}
                                                    {formatNumber(
                                                        stats.total_addresses
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                        <div className={styles.card}>
                                            <div className={styles.cardInfo}>
                                                <p className={styles.cardName}>
                                                    LAST SAFE BLOCK
                                                </p>
                                                {/* Change to Value of LAST SAFE BLOCK*/}
                                                <p
                                                    className={`${styles.cardValue} ${styles.textalignright}`}>
                                                    {gasPrices}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.maincard}>
                            <div className={`${styles.cards} ${styles.wid33}`}>
                                <div className={styles.rightfont}>
                                    TRANSACTION HISTORY IN 14 DAYS
                                </div>
                                <div className={styles.totalbar}>
                                    <div className={styles.kbar}>
                                        <div>1150K</div>
                                        <div>950k</div>
                                    </div>
                                    <div className={styles.graphbar}>
                                        <div>
                                            <img
                                                src={graph_svg}
                                                style={{ width: '100%' }}
                                                alt="graph_svg"
                                            />
                                        </div>
                                        <div className={styles.numbar}>
                                            <div>Jun 26</div>
                                            <div>Aug 2</div>
                                            <div>Aug 9</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </section>
            <div className={styles.latestbody}>
                <section className={styles.latestSection}>
                    <div className={styles.headLatest}>
                        <h1 className={styles.sectionName}>Latest blocks</h1>
                    </div>
                    <LatestBlocks LatestBlockArray={blocks} />
                    <div className={styles.buttonposition}>
                        <NavLink className={styles.viewAll} to="/blocks">
                            View all blocks
                        </NavLink>
                    </div>
                </section>
                {
                    <section className={styles.latestSection}>
                        <div className={styles.headLatest}>
                            <h1 className={styles.sectionName}>
                                Latest transactions
                            </h1>
                        </div>
                        <LatestTransactions
                            LatestTransactionArray={transactions}
                        />
                        <div className={styles.buttonposition}>
                            <NavLink
                                className={styles.viewAll}
                                to="/transactions">
                                View all transactions
                            </NavLink>
                        </div>
                    </section>
                }
            </div>
        </div>
    )
}
